.tooltip{scale:1!important;margin-left:.2em;color:#00000080}.tooltip:hover{color:#000;background-color:#f4f4f6;cursor:pointer}::ng-deep .ant-tooltip-inner{border-radius:5px!important}::ng-deep .ant-tooltip-arrow{display:none}
/*# sourceMappingURL=tooltip.component-XPECNDQC.css.map */
